import { render, staticRenderFns } from "./BlankComponent.vue?vue&type=template&id=be2af4d2&scoped=true"
import script from "./BlankComponent.vue?vue&type=script&lang=js"
export * from "./BlankComponent.vue?vue&type=script&lang=js"
import style0 from "./BlankComponent.vue?vue&type=style&index=0&id=be2af4d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2af4d2",
  null
  
)

export default component.exports